import { render, staticRenderFns } from "./CollapsibleDataTable.vue?vue&type=template&id=01697949&lang=pug&"
import script from "./CollapsibleDataTable.vue?vue&type=script&lang=ts&"
export * from "./CollapsibleDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports